'use client';

import { useEffect } from 'react';
import type { ReactNode } from 'react';
import {
  applyBranding,
  loadBranding,
} from '@/src/lib/tenant-branding';

export function BrandingProvider({
  tenantId,
  children,
}: {
  tenantId: string;
  children: ReactNode;
}) {
  useEffect(() => {
    const update = () => applyBranding(loadBranding(tenantId));
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    window.addEventListener('storage', update);
    window.addEventListener('kontora-branding-change', update);
    return () => {
      observer.disconnect();
      window.removeEventListener('storage', update);
      window.removeEventListener('kontora-branding-change', update);
    };
  }, [tenantId]);

  return <>{children}</>;
}
